import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { NotificationComponent } from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

@Component({
  selector: 'td-wb-td-agreement',
  templateUrl: './td-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [NgTemplateOutlet, NotificationComponent]
})
export class TdAgreementComponent extends AgreementsDateBaseDirective {
}
